/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import { LMWindow } from "logic/windowOpener";

let _lmWindow: LMWindow | null = null;

export const getLmWindow = () => _lmWindow;
export const setLmWindow = (lmWindow: LMWindow | null) => {
    _lmWindow = lmWindow;
};

export const isOpenLmWindow = () => getLmWindow() != null;
